import styled from "styled-components"
import { globalMixins } from "../../../assets/styles/styled-components"

const getProgramColor = (props) => {
  switch (props.programCategory) {
    case "undergraduate":
      return (props) => props.theme.colors.undergraduate
    case "masters":
      return (props) => props.theme.colors.masters
    case "mba":
      return (props) => props.theme.colors.mba
    case "doctorate":
      return (props) => props.theme.colors.doctorate
    case "executive":
      return (props) => props.theme.colors.executive
    default:
      return (props) => props.theme.colors.darkGrey
  }
}

export const StyledProgramDetailAttr = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  &:nth-of-type(1) {
    margin-top: 0;
  }

  & > i {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 18px;
    min-width: 18px;
    margin-right: 16px;

    & svg {
      color: ${getProgramColor};
    }
  }
  & > p {
    ${globalMixins.typography.body}
  }
`
